
export const common = {
  // Navigation
  home: '首頁',
  courts: '球場',
  sessions: '開局',
  learning: '學習',
  scoreboard: '計分板',
  login: '登入',
  signup: '註冊',
  
  // Navigation object for footer links
  nav: {
    home: '首頁',
    courts: '球場',
    sessions: '開局',
    learning: '學習',
    scoreboard: '計分板',
    login: '登入',
    signup: '註冊'
  },

  // Auth pages
  auth: {
    // Login page
    welcome_back: '歡迎回來',
    sign_in_subtitle: '登入您的匹克球社群帳戶',
    email_address: '電子郵件地址',
    password: '密碼',
    remember_me: '記住我',
    forgot_password: '忘記密碼？',
    sign_in: '登入',
    signing_in: '登入中...',
    or_continue_with: '或使用以下方式繼續',
    google: 'Google',
    apple: 'Apple',
    no_account: '還沒有帳戶？',
    sign_up_free: '免費註冊',
    enter_email: '輸入您的電子郵件',
    enter_password: '輸入您的密碼',
    
    // Signup page
    join_community: '加入社群',
    create_account_subtitle: '建立您的匹克球社群帳戶',
    nickname: '暱稱',
    confirm_password: '確認密碼',
    choose_nickname: '選擇暱稱',
    create_password: '建立密碼',
    confirm_your_password: '確認您的密碼',
    password_min_length: '至少需要6個字元',
    agree_terms: '我同意',
    terms_of_service: '服務條款',
    and: '和',
    privacy_policy: '隱私政策',
    create_account: '建立帳戶',
    creating_account: '建立帳戶中...',
    or_sign_up_with: '或使用以下方式註冊',
    already_have_account: '已經有帳戶？',
    sign_in_here: '在此登入',
    
    // Error messages
    passwords_not_match: '密碼不符',
    password_min_6_chars: '密碼至少需要6個字元',
    agree_terms_required: '請同意條款和條件',
    account_created_success: '帳戶建立成功！您現在可以登入。',
    
    // Social auth not available
    social_auth_unavailable: '社交登入目前無法使用。請使用電子郵件和密碼登入。'
  },
  
  // Common actions
  search: '搜尋',
  filter: '篩選',
  book: '預約',
  create: '建立',
  cancel: '取消',
  confirm: '確認',
  save: '儲存',
  edit: '編輯',
  delete: '刪除',
  view: '查看',
  details: '詳情',
  close: '關閉',
  
  // Court related
  'view_details': '查看詳情',
  'book_session': '預約開局',
  'create_session': '建立開局',
  amenities: '設施',
  location: '位置',
  availability: '可用性',
  
  // Session related
  'session_time': '開局時間',
  'session_date': '開局日期',
  players: '球員',
  skill_level: '技能等級',
  'available_sessions': '可用開局',
  'my_bookings': '我的預約',
  'session_title': '匹克球開局',
  'sessions_subtitle': '與球友一起參加或建立開局',
  'sessions_title': '匹克球開局',
  'create_session': '建立開局',
  'book_session': '預約開局',
  'session_details': '開局詳情',
  'session_information': '開局資訊',
  'court_details': '球場詳情',
  'court_facilities': '球場設施',
  'equipment': '設備',
  'additional_notes': '額外備註',
  'participants': '參與者',
  'spots_left': '剩餘名額',
  'no_sessions_available': '沒有可用的開局',
  'no_booked_sessions': '沒有已預約的開局',
  'no_sessions_message': '稍後再查看新的開局或建立您自己的！',
  'no_booked_message': '預約一個開局開始與社群一起玩！',
  'browse_sessions': '瀏覽開局',
  'confirm_booking': '確認預約',
  'booking_confirmed': '預約已確認！',
  'booking_success_message': '您已成功加入此開局。',
  'booking': '預約中...',
  'at': '於',
  'by': '由',
  'organized_by': '主辦者',
  'joined': '加入於',
  'open_spot': '空缺位置',
  'spots_remaining': '剩餘位置',
  'book_this_session': '預約此開局',
  'session_full': '開局已滿',
  'full': '已滿',
  'booked': '已預約',
  'group_chat': '群組聊天',
  'skill_beginner': '初學者',
  'skill_intermediate': '中級',
  'skill_advanced': '高級',
  'skill_expert': '專家',
  'skill_mixed': '混合',
  
  // Create Session Form translations
  'create_new_session': '建立新開局',
  'session_information': '開局資訊',
  'session_title_required': '開局標題 *',
  'session_title_placeholder': '例如：晨間雙打練習',
  'description': '描述',
  'description_placeholder': '描述您的開局、期望內容、技能等級要求...',
  'court_schedule': '球場與時間安排',
  'select_court_required': '選擇球場 *',
  'choose_court': '選擇球場...',
  'date_required': '日期 *',
  'start_time_required': '開始時間 *',
  'end_time_required': '結束時間 *',
  'session_settings': '開局設定',
  'maximum_participants': '最大參與人數',
  'players_singles': '2位球員（單打）',
  'players_doubles': '4位球員（雙打）',
  'players_round_robin': '6位球員（循環賽）',
  'players_tournament': '8位球員（錦標賽）',
  'skill_level': '技能等級',
  'mixed_all_levels': '混合（所有等級）',
  'beginner': '初學者',
  'intermediate': '中級',
  'advanced': '高級',
  'expert': '專家',
  'price_per_person': '每人價格（港幣）',
  'price_placeholder': '免費開局請留空',
  'free_session_note': '留空以建立免費開局',
  'additional_details': '額外詳情',
  'equipment_requirements': '設備與要求',
  'equipment_placeholder': '例如：提供球拍，請攜帶水瓶',
  'additional_notes': '額外備註',
  'notes_placeholder': '參與者的任何額外資訊...',
  'characters': '字元',
  'creating_session': '建立開局中...',
  
  // Validation messages
  'session_title_required_msg': '開局標題為必填項',
  'court_selection_required': '請選擇球場',
  'date_selection_required': '請選擇日期',
  'start_time_required_msg': '請選擇開始時間',
  'end_time_required_msg': '請選擇結束時間',
  'future_date_required': '開局必須安排在未來的日期和時間',
  'end_time_after_start': '結束時間必須在開始時間之後',
  'session_created_success': '開局建立成功！您已自動註冊為第一位參與者。',
  'session_creation_failed': '建立開局失敗，請重試。',
  
  // Group Chat translations
  'no_messages_yet': '尚無訊息',
  'start_the_conversation': '開始與您的球友對話！',
  'type_your_message': '輸入您的訊息...',
  'characters': '字元',
  'participants': '參與者',
  
  // Common phrases
  welcome: '歡迎來到',
  loading: '載入中...',
  error: '錯誤',
  success: '成功',
  'no_results': '找不到結果',
  
  // Footer
  footer: {
    description: '加入香港頂尖的匹克球社群。與球友聯繫、預約球場，並透過 HKPicklePlay 提升您的球技。',
    quickLinks: '快速連結',
    contact: '聯絡我們',
    sendMessage: '發送訊息'
  },
  'all_rights_reserved': '版權所有',
  'privacy_policy': '隱私政策',
  'terms_of_service': '服務條款',
  contact: '聯絡我們',
  
  // Language
  language: '語言',
  english: 'English',
  'traditional_chinese': '繁體中文',
  
  // Group Chat
  groupChat: '群組聊天',
  noMessages: '尚無訊息',
  startConversation: '成為第一個開始對話的人！',
  typeMessage: '輸入您的訊息...',
  characters: '字元',

  // Home page
  'find_courts': '尋找球場',
  'join_sessions': '加入開局',
  'learn_improve': '學習與提升',
  'track_scores': '追蹤分數',
  'find_courts_desc': '探索香港各地的匹克球場，包含詳細資訊、設施和預約選項。',
  'join_sessions_desc': '預約並參與各種技能等級的有組織匹克球開局。',
  'learn_improve_desc': '獲取教學、指南和技巧來提升您的匹克球技能和知識。',
  'track_scores_desc': '使用我們的互動計分板追蹤比賽並保存您的比賽歷史。',
  'active_courts': '活躍球場',
  'community_members': '社群成員',
  'weekly_sessions': '每週開局',
  'districts_covered': '覆蓋地區',
  'everything_you_need': '匹克球所需的一切',
  'everything_desc': '從尋找完美球場到追蹤您的進步，HKPicklePlay 提供您享受和改善匹克球體驗所需的所有工具。',
  'ready_to_start': '準備開始玩了嗎？',
  'ready_desc': '加入香港數千名匹克球愛好者。找到您的下一場比賽，提升您的技能，成為我們精彩社群的一部分。',
  'get_started': '開始使用',
  'browse_courts': '瀏覽球場',
  'homepage_subtitle': '香港頂尖的匹克球社群平台。與球友聯繫、探索球場，提升您的球技。',

  // Courts page
  'find_pickleball_courts': '尋找匹克球場',
  'discover_best_courts': '探索香港最佳球場',
  'search_courts': '搜尋球場',
  'search_by_name': '按名稱或位置搜尋...',
  'district': '地區',
  'all_districts': '所有地區',
  'clear_filters': '清除篩選',
  'showing_courts': '顯示',
  'of_courts': '球場，共',
  'courts': '球場',
  'reviews': '評論',
  'book_now': '立即預約',
  'no_courts_found': '找不到球場',
  'try_adjusting': '嘗試調整您的搜尋條件或篩選器',
  'clear_all_filters': '清除所有篩選器',

  // Learning page
  'learning_center': '學習中心',
  'master_skills': '透過專家教學和指南掌握您的匹克球技能',
  'search_tutorials': '搜尋教學、指南和資源...',
  'all_resources': '所有資源',
  'basics': '基礎',
  'techniques': '技巧',
  'strategy': '策略',
  'equipment': '設備',
  'rules': '規則',
  'featured_content': '精選內容',
  'new_course': '新課程',
  'intermediate': '中級',
  'complete_mastery': '完整匹克球精通課程',
  'comprehensive_series': '涵蓋從基本原理到高級錦標賽策略的全面10部分影片系列。非常適合希望將比賽提升到新水平的球員。',
  'videos_hours': '部影片 • ',
  'hours': '小時',
  'start_learning': '開始學習',
  'resources_found': '找到資源',
  'beginner': '初學者',
  'advanced': '高級',
  'all_levels': '所有等級',
  'watch_now': '立即觀看',
  'read_more': '閱讀更多',
  'no_resources_found': '找不到資源',
  'try_adjusting_search': '嘗試調整您的搜尋或類別篩選器',
  'recommended_learning': '推薦學習路徑',
  'start_with_basics': '1. 從基礎開始',
  'learn_rules_layout': '學習規則、球場佈局和基本設備',
  'master_techniques': '2. 掌握技巧',
  'practice_serves': '練習發球、截擊和球的放置',
  'develop_strategy': '3. 發展策略',
  'learn_positioning': '學習定位、戰術和比賽策略',
  'join_learning_community': '加入我們的學習社群',
  'connect_with_players': '與其他球員聯繫，提出問題，並在我們的社群論壇中分享您的進步。',
  'join_community': '加入社群',

  // Scoreboard page - Updated terminology
  'pickleball_score': '匹克球計分',
  'rules': '規則',
  'game_configuration': '比賽設定',
  'scoring_system': '計分系統',
  'side_out_traditional': '發球權得分（傳統）',
  'rally_scoring': '直接得分',
  'player_mode': '球員模式',
  'singles_1v1': '單打（1對1）',
  'doubles_2v2': '雙打（2對2）',
  'winning_score': '獲勝分數',
  'points': '分',
  'custom': '自訂',
  'set': '設定',
  'current_points': '目前：',
  'must_win_by_2': '分（必須領先2分獲勝）',
  'team_1': '隊伍1',
  'team_2': '隊伍2',
  'player_1_name': '球員1姓名',
  'player_2_name': '球員2姓名',
  'start_game': '開始比賽',
  'add_point': '加分',
  'serving': '發球中',
  'player': '球員',
  'wins': '獲勝！',
  'final_score': '最終比分：',
  'new_game': '新比賽',
  'switch_server': '換發球員',
  'undo': '復原',
  'setup': '設定',
  'pickleball_scoring_rules': '匹克球計分規則',
  'side_out_scoring': '發球權得分（傳統）',
  'only_serving_team': '• 只有發球隊可以得分',
  'games_to_11': '• 比賽通常打到11分',
  'win_by_2': '• 必須領先2分獲勝',
  'server_switches': '• 發球隊失去回合時換發球',
  'doubles_each_serves': '• 雙打：每位球員都發球後才換隊',
  'rally_scoring_desc': '直接得分',
  'either_team_scores': '• 任一隊都可以在任何回合得分',
  'games_to_15': '• 比賽通常打到15分',
  'server_switches_each': '• 每分後換發球',
  'faster_paced': '• 節奏更快的比賽',
  'serving_rules': '發球規則',
  'singles': '單打',
  'server_alternates': '• 發球在隊伍間交替',
  'serve_right_even': '• 分數為偶數時從右側發球',
  'serve_left_odd': '• 分數為奇數時從左側發球',
  'doubles': '雙打',
  'both_players_serve': '• 兩位球員都發球後才換隊',
  'score_format': '• 分數格式：隊1-隊2-發球員',
  'first_serve_002': '• 比賽首次發球從0-0-2開始',
  'prevents_advantage': '• 這防止了第一隊的優勢',

  // Additional buttons and actions
  'try_again': '重試',
  'loading_courts': '載入球場中...',
  'failed_to_load': '載入失敗，請重試。',

  // Profile page translations
  profile_info: '個人資料',
  my_bookings: '我的預約',
  score_history: '比賽記錄',
  messages: '訊息',
  edit_profile: '編輯個人資料',
  cancel: '取消',
  save_changes: '儲存變更',
  profile_information: '個人資料資訊',
  nickname: '暱稱',
  email: '電子郵件',
  phone: '電話',
  location: '地點',
  skill_level: '技能等級',
  bio: '個人簡介',
  not_provided: '未提供',
  member_since: '會員自',
  loading_profile: '載入個人資料中...',
  profile_updated_successfully: '個人資料更新成功！',
  failed_to_save_profile: '儲存個人資料失敗，請重試。',
  enter_your_phone_number: '請輸入您的電話號碼',
  enter_your_location: '請輸入您的地點',
  tell_us_about_yourself: '告訴我們關於您的資訊...',
  no_bio_provided_yet: '尚未提供個人簡介。',
  confirmed: '已確認',
  pending: '待確認',
  win: '勝利',
  loss: '失敗',
  no_messages_yet: '尚無訊息',
  conversations_will_appear_here: '與其他會員的對話將顯示在這裡',
  find_users: '尋找用戶',
  search_users: '搜尋用戶...',
  start_conversation: '開始對話',
  send_message: '發送訊息',
  type_your_message: '輸入您的訊息...',
  no_users_found: '找不到用戶',
  try_different_search: '請嘗試不同的搜尋條件',
  online: '在線',
  offline: '離線',
  new_conversation: '新對話',
  back_to_messages: '返回訊息',

  // Create Session Form
  create_new_session: '建立新開局',
  session_information: '開局資訊',
  session_title: '開局標題',
  session_title_required: '開局標題為必填項',
  session_title_placeholder: '例如：晨間雙打練習',
  description: '描述',
  description_placeholder: '描述您的開局、期望內容、技能等級要求...',
  court_schedule: '球場與時間安排',
  select_court: '選擇球場',
  select_court_required: '請選擇球場',
  choose_court: '選擇球場...',
  date: '日期',
  start_time: '開始時間',
  end_time: '結束時間',
  session_settings: '開局設定',
  maximum_participants: '最大參與人數',
  skill_level: '技能等級',
  price_per_person: '每人價格',
  price_placeholder: '免費開局請留空',
  price_note: '留空即為免費開局',
  equipment_requirements: '設備與要求',
  equipment_placeholder: '例如：提供球拍，請自備水瓶',
  additional_notes: '額外備註',
  notes_placeholder: '給參與者的額外資訊...',
  
  // Player options
  players_singles: '位球員（單打）',
  players_doubles: '位球員（雙打）',
  players_round_robin: '位球員（循環賽）',
  players_tournament: '位球員（錦標賽）',
  
  // Skill levels
  skill_mixed: '混合（所有等級）',
  skill_beginner: '初學者',
  skill_intermediate: '中級',
  skill_advanced: '進階',
  skill_expert: '專家',
  
  // Validation messages
  please_select_court: '請選擇球場',
  please_select_date: '請選擇日期',
  please_select_start_time: '請選擇開始時間',
  please_select_end_time: '請選擇結束時間',
  session_future_time: '開局必須安排在未來的日期和時間',
  end_time_after_start: '結束時間必須晚於開始時間',
  session_created_successfully: '開局建立成功！',
  creating_session: '建立開局中...',
  failed_create_session: '建立開局失敗，請重試。',
  auto_enrolled_message: '開局建立成功！您已自動註冊為第一位參與者。'
};

export default common;
